import { createFieldSelectorHook } from 'src/lib/sweetState';

import { WorkspaceStore } from './WorkspaceStore';

export const useCurrentWorkspaces = createFieldSelectorHook(WorkspaceStore, 'currentWorkspaces');
